import { createSlice } from "@reduxjs/toolkit";
import { ToastInfo } from "./../shared/models/ToastInfo";
import { CustomerAttributeConstraint } from "../shared/models/CustomerAttributeConstraint";
import { DialogInfo } from "@/shared/models/DialogInfo";
import { DialogType } from "@/shared/enums";

const initialState = {
  dialogInfo: { isShow: false, title: "", content: "", dialogType: DialogType.info } as DialogInfo,
  toastInfo: { isShow: false, text: "", type: "info" } as ToastInfo,
  loadPanelVisible: false,
  customerAttributeConstraints: [] as CustomerAttributeConstraint[],
};

const shareSlice = createSlice({
  name: "share",
  initialState: initialState,
  reducers: {
    setDialogInfo(state, action) {
      state.dialogInfo = action.payload;
    },
    hideDialogInfo(state, action) {
      state.dialogInfo.isShow = false;
    },
    setToastInfo(state, action) {
      state.toastInfo = { text: action.payload, isShow: true, type: "info" };
    },
    setToastError(state, action) {
      state.toastInfo = { text: action.payload, isShow: true, type: "error" };
    },
    closeToast(state, action) {
      state.toastInfo = { isShow: false, text: "", type: "info" };
    },
    setLoadPanelVisible(state, action) {
      state.loadPanelVisible = action.payload;
    },
    setCustomerAttributeConstraints(state, action) {
      state.customerAttributeConstraints = action.payload;
    },
  },
});

export const { setDialogInfo, hideDialogInfo, setToastInfo, setToastError, closeToast, setLoadPanelVisible, setCustomerAttributeConstraints } = shareSlice.actions;
export const shareReducer = shareSlice.reducer;

// Selector
export const selectDialogInfo = (state: any) => state.share.dialogInfo as DialogInfo;
export const selectToastInfo = (state: any) => state.share.toastInfo as ToastInfo;
export const selectLoadPanelVisible = (state: any) => state.share.loadPanelVisible as boolean;
export const selectCustomerAttributeConstraints = (state: any) => state.share.customerAttributeConstraints as CustomerAttributeConstraint[];
